import { useSelector } from "react-redux";

import { IStore } from "../interfaces/IStore";
import { ISystemFeedbackState } from "../interfaces/ISystemFeedback";

export const useSystemFeedback = (): ISystemFeedbackState => useSelector((state: IStore) => state.systemFeedback);
